import { render, staticRenderFns } from "./OtherBusinessKYC.vue?vue&type=template&id=4747fa32&scoped=true"
import script from "./OtherBusinessKYC.vue?vue&type=script&lang=js"
export * from "./OtherBusinessKYC.vue?vue&type=script&lang=js"
import style0 from "./OtherBusinessKYC.vue?vue&type=style&index=0&id=4747fa32&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747fa32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4747fa32')) {
      api.createRecord('4747fa32', component.options)
    } else {
      api.reload('4747fa32', component.options)
    }
    module.hot.accept("./OtherBusinessKYC.vue?vue&type=template&id=4747fa32&scoped=true", function () {
      api.rerender('4747fa32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/businessKYC/components/OtherBusinessKYC.vue"
export default component.exports